export const PROGRAM_DURATIONS = {
  0: 'Kurzzeitprogramme',
  8: '2 Monate',
  12: '3 Monate',
  16: '4 Monate',
  24: '1 Schulhalbjahr',
  36: '3/4 Jahr',
  48: '1 Schuljahr'
}

export const PROGRAM_PRICINGS = {
  5000: 'bis 5.000€',
  10000: 'bis 10.000€',
  15000: 'bis 15.000€',
  20000: 'bis 20.000€',
  25000: 'bis 25.000€'
}

export const SORT_ORDERS = {
  popularity: 'Beliebtheit',
  price_ascending: 'Preis (aufsteigend)',
  price_descending: 'Preis (absteigend)'
}

export const FLAGS = {
  'flight_incl': 'incl. Flug',
  'prep_meeting': 'incl. Vorbereitungstreffen',
  'parents_meeting': 'incl. Elterntreffen',
  'after_meeting': 'incl. Nachtreffen',
  'siblings_discount': 'Geschwisterrabatt',
  'own_guest_family_discount': 'eigene Gastfamilie',
  'scholarships': 'Stipendien',
  'placement_guaranty': 'Platzierungsgarantie',
  'airport_intro': 'Flughafeneinweisung',
  'accompanied_flight': 'Begleiteter Flug',
  'travel_offer': 'Reiseangebote Gastland'
}

export const FLAG_DEFAULTS = {
  'flight_incl': false,
  'prep_meeting': false,
  'parents_meeting': false,
  'after_meeting': false,
  'siblings_discount': false,
  'own_guest_family_discount': false,
  'scholarships': false,
  'placement_guaranty': false,
  'airport_intro': false,
  'accompanied_flight': false,
  'travel_offer': false,
  'no_partner': false
}

export const PRIORITY_COUNTRY_CODES = [
  'US',
  'CA',
  'GB',
  'NZ',
  'AU'
]

export const SORT_ORDER_DETAILS = 'In der Sortierung nach Beliebtheit wird pro Organisation jeweils das günstigste Programm mit der längsten Laufzeit angezeigt. Die Programme sind sortiert nach Anzahl der aktuellsten Bewertungen der Organisation (letzte 6 Monate, höchste Anzahl zuerst). Mit den Filtermöglichkeiten lassen sich die Ergebnisse auf Ihre Bedürfnisse anpassen. Bei anderen Sortierungen werden alle Programme der Organisationen gelistet.'
